import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import { ModuleDoneType, ModuleType, PlanType } from "../../templates/types";

export const HomeRenovationTemplate: PlaniraTemplate = {
  planType: PlanType.Planira,
  type: PlanTemplateType.HomeRenovation,
  title: "Home Renovation",
  titleHelp: "Renovate the kitchen, build a Pergola, Deck or Patio",
  description:
    "Transform your living space. Plan and execute your renovation projects.",
  longDescription: "",
  emoji: "🏡",
  image: require("../../assets/illustrations/Woodworker-bro.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Home renovation",
          isDraggable: false,
          emoji: "🏡",
        },
      ],
    },

    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Expense,
          doneType: ModuleDoneType.None,
          title: "Expenses",
          emoji: "💰",
        },
      ],
    },
  ],
};
